// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8da5e6dae8fd89d46bad","655":"f21fc20ef58f71904f57"}[chunkId] + ".js";
};